/**
 * Extract unique platforms for a post from all possible sources.
 */
export function getPostPlatforms(post) {
  const platforms = [];
  if (post.platform_statuses) {
    for (const p of Object.keys(post.platform_statuses)) {
      platforms.push(p);
    }
  }
  if (post.platforms && Array.isArray(post.platforms)) {
    for (const p of post.platforms) {
      if (!platforms.includes(p)) platforms.push(p);
    }
  }
  if (post.platform && !platforms.includes(post.platform)) {
    platforms.push(post.platform);
  }
  return platforms;
}

/**
 * Check if any platform status has a raw_response.
 */
export function hasRawResponse(post) {
  return post.platform_statuses && Object.values(post.platform_statuses).some(ps => ps?.raw_response);
}

/**
 * Format a status string (e.g. 'delete_pending' → 'Delete Pending').
 */
export function getStatusLabel(status) {
  if (!status) return '';
  return status.replace(/_/g, ' ').replace(/\b\w/g, c => c.toUpperCase());
}

/**
 * Format a post date for display.
 */
export function formatPostDate(dateStr) {
  if (!dateStr) return '';
  const date = new Date(dateStr);
  return date.toLocaleDateString('en-US', {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
}

/**
 * Format a scheduled time for display (short format).
 */
export function formatScheduledTime(dateStr) {
  if (!dateStr) return '';
  return new Date(dateStr).toLocaleTimeString('en-US', {
    hour: 'numeric',
    minute: '2-digit',
    hour12: true
  });
}

/**
 * Post status constants.
 */
export const POST_STATUS = {
  DRAFT: 'draft',
  SCHEDULED: 'scheduled',
  PUBLISHED: 'published',
  PUBLISH_PENDING: 'publish_pending',
  PUBLISH_FAILED: 'publish_failed',
  DELETE_PENDING: 'delete_pending',
  DELETED: 'deleted',
  DELETE_FAILED: 'delete_failed',
};

/**
 * Platform status constants.
 */
export const PLATFORM_STATUS = {
  PENDING: 'pending',
  PUBLISHED: 'published',
  PUBLISH_FAILED: 'publish_failed',
  DELETING: 'deleting',
  DELETED: 'deleted',
  DELETE_FAILED: 'delete_failed',
};

/**
 * Common statuses that block re-publishing.
 */
export const PUBLISHED_STATUSES = [
  POST_STATUS.PUBLISHED,
  POST_STATUS.PUBLISH_PENDING,
  POST_STATUS.PUBLISH_FAILED,
  POST_STATUS.DELETE_PENDING,
  POST_STATUS.DELETED,
  POST_STATUS.DELETE_FAILED,
];

/**
 * Common statuses that allow editing.
 */
export const EDITABLE_STATUSES = [
  POST_STATUS.DRAFT,
  POST_STATUS.SCHEDULED,
  POST_STATUS.PUBLISHED,
];

/**
 * Common statuses that allow publishing.
 */
export const PUBLISHABLE_STATUSES = [
  POST_STATUS.DRAFT,
  POST_STATUS.SCHEDULED,
];
